import Resource from "./resource";
import request from "../utils/request";

/**
 * Activity types for logging user actions
 */
export const ActivityTypes = {
  // User Management
  USER_LOGIN: "USER_LOGIN",
  USER_LOGOUT: "USER_LOGOUT",
  USER_CREATED: "USER_CREATED",
  USER_UPDATED: "USER_UPDATED",
  USER_DELETED: "USER_DELETED",
  USER_INVITED: "USER_INVITED",
  USER_ROLE_CHANGED: "USER_ROLE_CHANGED",

  // Dashboard Management
  DASHBOARD_CREATED: "DASHBOARD_CREATED",
  DASHBOARD_UPDATED: "DASHBOARD_UPDATED",
  DASHBOARD_DELETED: "DASHBOARD_DELETED",
  DASHBOARD_VIEWED: "DASHBOARD_VIEWED",

  // Data Management
  DATA_UPLOADED: "DATA_UPLOADED",
  DATA_PUSHED: "DATA_PUSHED",
  DATA_DELETED: "DATA_DELETED",
  DATA_UPDATED: "DATA_UPDATED",
  FILE_UPLOADED: "FILE_UPLOADED",
  FILE_DELETED: "FILE_DELETED",

  // Role Management
  ROLE_CREATED: "ROLE_CREATED",
  ROLE_UPDATED: "ROLE_UPDATED",
  ROLE_DELETED: "ROLE_DELETED",
};

/**
 * Human-readable descriptions for activity types
 */
export const ActivityDescriptions = {
  [ActivityTypes.USER_LOGIN]: "logged in",
  [ActivityTypes.USER_LOGOUT]: "logged out",
  [ActivityTypes.USER_CREATED]: "created a user",
  [ActivityTypes.USER_UPDATED]: "updated user profile",
  [ActivityTypes.USER_DELETED]: "deleted a user",
  [ActivityTypes.USER_INVITED]: "invited a user",
  [ActivityTypes.USER_ROLE_CHANGED]: "changed user role",

  [ActivityTypes.DASHBOARD_CREATED]: "created a dashboard",
  [ActivityTypes.DASHBOARD_UPDATED]: "updated a dashboard",
  [ActivityTypes.DASHBOARD_DELETED]: "deleted a dashboard",
  [ActivityTypes.DASHBOARD_VIEWED]: "viewed a dashboard",

  [ActivityTypes.DATA_UPLOADED]: "uploaded data",
  [ActivityTypes.DATA_PUSHED]: "pushed data to server",
  [ActivityTypes.DATA_DELETED]: "deleted data",
  [ActivityTypes.DATA_UPDATED]: "updated data",
  [ActivityTypes.FILE_UPLOADED]: "uploaded a file",
  [ActivityTypes.FILE_DELETED]: "deleted a file",

  [ActivityTypes.ROLE_CREATED]: "created a role",
  [ActivityTypes.ROLE_UPDATED]: "updated a role",
  [ActivityTypes.ROLE_DELETED]: "deleted a role",
};

/**
 * Handles activity log API operations
 */
class ActivityResource extends Resource {
  constructor() {
    super("activities");
  }

  /**
   * Get all activities with optional filters
   * @param {Object} query - Query parameters (page, limit, userId, type, etc.)
   * @returns {Promise}
   */
  getAll(query = {}) {
    return request({
      url: `/${this.uri}/`,
      method: "get",
      params: query,
    });
  }

  /**
   * Get activities for a specific user
   * @param {Number} userId
   * @param {Object} query
   * @returns {Promise}
   */
  getByUser(userId, query = {}) {
    return request({
      url: `/${this.uri}/user/${userId}/`,
      method: "get",
      params: query,
    });
  }

  /**
   * Log a new activity
   * @param {Object} activity - Activity data
   * @returns {Promise}
   */
  log(activity) {
    return request({
      url: `/${this.uri}/`,
      method: "post",
      data: {
        ...activity,
        timestamp: new Date().toISOString(),
      },
    });
  }
}

export default new ActivityResource();
